$( "#selling_plan_onetime" ).click(function() {
  $( "#discounted_price" ).hide();
  $( ".rc_label__frequency" ).hide();
  $( "#__product-subscription-info" ).hide();
  $( "#non_discounted_price" ).show();
  $('.product-form__cart-submit span').text('Add to Cart');
});
  
$( ".subtoggle" ).click(function() {
  $( "#discounted_price" ).show();
  $( "#non_discounted_price" ).hide();
    $( ".rc_label__frequency" ).show();
  $( "#__product-subscription-info" ).show();
  $('.product-form__cart-submit span').text('Subscribe Now');
});  

  
$( ".one-block .onetimez" ).click(function() {
  $( ".one-block .regular-price" ).show();
  $( ".one-block .onepercent" ).show();
  $( ".one-block .subpercent" ).hide();
  $( ".one-block .sub-price" ).hide();
  $( ".one-block .option-more-info" ).hide();
  $( ".one-block .option-more" ).hide();
  $('.one-block .p-inno-add-cart').text('Add To Cart');
});  

$( ".one-block .sub" ).click(function() {
  $( ".one-block .regular-price" ).hide();
    $( ".one-block .onepercent" ).hide();
  $( ".one-block .subpercent" ).show();
  $( ".one-block .sub-price" ).show();
  $( ".one-block .option-more-info" ).show();
  $( ".one-block .option-more" ).show();
  $('.one-block .p-inno-add-cart').text('Subscribe Now');
});  




$( ".two-block .onetimez" ).click(function() {
  $( ".two-block .onepercent" ).show();
  $( ".two-block .subpercent" ).hide();
  $( ".two-block .regular-price" ).show();
  $( ".two-block .sub-price" ).hide();
  $( ".two-block .option-more-info" ).hide();
   $( ".two-block .option-more" ).hide();
  $('.two-block .p-inno-add-cart').text('Add To Cart');
});  

$( ".two-block .sub" ).click(function() {
    $( ".two-block .onepercent" ).hide();
  $( ".two-block .subpercent" ).show();
  $( ".two-block .regular-price" ).hide();
  $( ".two-block .sub-price" ).show();
  $( ".two-block .option-more-info" ).show();
    $( ".two-block .option-more" ).show();
  $('.two-block .p-inno-add-cart').text('Subscribe Now');
});  


$( ".three-block .onetimez" ).click(function() {
    $( ".three-block .onepercent" ).show();
  $( ".three-block .subpercent" ).hide();
  $( ".three-block .regular-price" ).show();
  $( ".three-block .sub-price" ).hide();
  $( ".three-block .option-more-info" ).hide();
   $( ".three-block .option-more" ).hide();
  $('.three-block .p-inno-add-cart').text('Add To Cart');
});  

$( ".three-block .sub" ).click(function() {
    $( ".three-block .onepercent" ).hide();
  $( ".three-block .subpercent" ).show();
  $( ".three-block .regular-price" ).hide();
  $( ".three-block .sub-price" ).show();
  $( ".three-block .option-more-info" ).show();
    $( ".three-block .option-more" ).show();
  $('.three-block .p-inno-add-cart').text('Subscribe Now');
});  








$(document).ready(function(){
  
  if($("input:radio[class='className']").is(":checked")) {
     //write your code         
}
  
  
    if (!$("input[id='selling_plan_onetime']:checked").val()) {
         $( "#discounted_price" ).show();
  $( "#non_discounted_price" ).hide();
    }
    else {
        $( "#discounted_price" ).hide();
  $( "#non_discounted_price" ).show();
    }
});



window.onload=function() {
  var rads = document.getElementsByName("selling_plan");
  for (var i=0;i<rads.length;i++) {
  
    if (rads[i].checked) {
      rads[i].click();
    }
  }
};


window.onload=function() {
  var rads = document.getElementsByClassName("recheck");
  for (var i=0;i<rads.length;i++) {
  
    if (rads[i].checked) {
      rads[i].click();
    }
  }
};
